import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  useChDeleteTimeWindowMutation,
  useChDeleteTimeWindowMutation$data,
} from "@/modules/patients/services/ch/__generated__/useChDeleteTimeWindowMutation.graphql"
import { refetchChPatientAgenda } from "@/modules/patients/services/usePatientAgenda"

export const Ch_DeleteTimeWindowMutation = graphql`
  mutation useChDeleteTimeWindowMutation($id: ID!) {
    ch_deleteTimeWindow(input: { id: $id }) {
      ch_TimeWindow {
        id: id
      }
    }
  }
`

type TimeWindowDeleteProps = {
  id: string
  onSuccess?: (data: useChDeleteTimeWindowMutation$data) => void
}

export const useDeleteSwissTimeWindowMutation = () => {
  return useMutation<useChDeleteTimeWindowMutation>(Ch_DeleteTimeWindowMutation)
}

export const useSwissTimeWindowDeleteMutation = (patientId: string, language: string) => {
  const [deleteSwissTimeWindow] = useDeleteSwissTimeWindowMutation()

  const deleteTimeWindow = ({ id }: TimeWindowDeleteProps) => {
    deleteSwissTimeWindow({
      variables: {
        id,
      },
      onCompleted: () => {
        refetchChPatientAgenda(patientId, language)
      },
    })
  }

  return { deleteTimeWindow }
}
